export const quizPlayer: Record<string, string> = {
  'qplay.connecting': 'Đang kết nối...',
  'qplay.enterCode': 'Nhập mã game',
  'qplay.codePlaceholder': 'XXXXXX',
  'qplay.next': 'Tiếp',
  'qplay.qr.scan': 'Quét QR',
  'qplay.qr.hint': 'Chĩa camera vào mã QR của phòng chơi',
  'qplay.qr.cameraError': 'Không mở được camera — cấp quyền hoặc nhập mã tay',
  'qplay.back': '← Quay lại',
  'qplay.enterName': 'Nhập tên của bạn',
  'qplay.game': 'Game',
  'qplay.namePlaceholder': 'Tên của bạn',
  'qplay.join': 'Vào game',
  'qplay.errorInvalidCode': 'Vui lòng nhập mã game gồm 6 ký tự',
  'qplay.errorInvalidName': 'Vui lòng nhập tên của bạn',
  'qplay.errorNotOnTeam': 'Bạn không có trong đội nào của đợt Team Building này nên không vào chơi được.',
  'qplay.youreIn': 'Đã vào!',
  'qplay.waitingHost': 'Đợi host bắt đầu...',
  'qplay.question': 'Câu',
  'qplay.answered': 'Đã trả lời, đang chờ...',
  // Câu gõ chữ ("Vua Tiếng Việt")
  'qplay.typeAnswer': 'Gõ đáp án…',
  'qplay.submitAnswer': 'Gửi đáp án',
  'qplay.hintComing': 'Sẽ có gợi ý',
  'qplay.timeUp': 'Hết giờ!',
  'qplay.getReady': 'Sẵn sàng...',
  'quiz.bonus.title': 'Câu nhân ×{m} điểm!',
  'qplay.reconnecting': 'Mất kết nối — đang thử lại...',
  'qplay.slideWaiting': 'Đợi host...',
  'qplay.correct': 'Chính xác!',
  'qplay.wrong': 'Sai rồi!',
  'qplay.streakBonus': 'chuỗi đúng liên tiếp! bonus',
  'qplay.yourScore': 'Điểm của bạn',
  'qplay.waitingReveal': 'Đã trả lời — chờ kết quả...',
  'qplay.correctAnswer': 'Đáp án đúng',
  'qplay.points': 'Điểm',
  'qplay.time': 'Thời gian',
  'qplay.rank': 'Hạng',
  'qplay.score': 'Tổng điểm',
  'qplay.fastestResponders': 'Top 5 nhanh nhất',
  'qplay.leaderboard': 'Bảng xếp hạng',
  'qplay.you': '(Bạn)',
  'qplay.gameOver': 'Kết thúc!',
  'qplay.rateGame': 'Đánh giá trò chơi',
  'qplay.feedbackPlaceholder': 'Để lại phản hồi của bạn...',
  'qplay.submitFeedback': 'Gửi đánh giá',
  'qplay.feedbackThanks': 'Cảm ơn bạn đã đánh giá!',
  'qplay.playAgain': 'Chơi lại',
  'qplay.gameEnded': 'Ván chơi đã kết thúc',
  'qplay.backToJoin': 'Về trang chủ',
  'qplay.captainBadge': 'Đội trưởng',
  'qplay.captainPickTitle': 'Chọn thành viên cho đội',
  'qplay.captainPickHint': 'Chọn người chơi',
  'qplay.captainPickEmpty': 'Không còn ai để chọn',
  'qplay.teamStreak': 'chuỗi đội',
  'qplay.teamRank': 'Hạng đội',
  'qplay.teamLeaderboard': 'Bảng xếp hạng đội',
  'qplay.topPlayers': 'Top người chơi',
  'qplay.scoringSum': 'Tổng điểm',
  'qplay.scoringAverage': 'Điểm TB',
  'qplay.employeeModeNote': 'Quiz này tính S-point Supernova Connect: kết quả gắn với tài khoản của bạn.',
};
